





































































import { WithConfirmModal } from '@/components/organisms/confirm-modal/with-confirm-modal'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import { Context, ContextFactory } from '@/models/order-history/status/context/context'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CancelCode, OrderHistoryApiService } from '@spa/services/api/orderHistory'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import SpaDropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import CancelIndicator from '@spa/components/organisms/indicator/CancelIndicator.vue'
import { getOrderCancellationState, OrderCancellationState } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'

import { Order } from '@spa/store/modules/orderHistory/types'
import { CancelReason } from './CancelReason'

@Component({
  components: {
    CancelIndicator,
    ConfirmModal,
    SpaDropdownSelect,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class HistoryDetailCancel extends Mixins<PluginMixin & WithConfirmModal>(PluginMixin, WithConfirmModal) {
  status: Status = Status.Pending
  cancelApiStatus: Status = Status.Pending

  showModal: boolean = false
  modalMessage: string = ''
  cancelReasons: any[] = CancelReason.list
  code: CancelCode | null = null
  comment: string = ''

  readonly orderHistoryApiService = new OrderHistoryApiService()

  get isLoading(): boolean {
    return this.status === Status.Loading || this.cancelApiStatus === Status.Loading
  }

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  get isFailed(): boolean {
    return this.status === Status.Failed
  }

  get queryOrderId(): string {
    return this.$route.params.id
  }

  get order(): Order {
    return this.$store.state.orderHistory.item
  }

  get orderStatusContext(): Context {
    return ContextFactory.fromStore(this.order).create()
  }

  get isPreOrder(): boolean {
    return this.order.isPreOrder
  }

  get orderCancellationState(): OrderCancellationState {
    return getOrderCancellationState(
      this.orderStatusContext,
      this.isPreOrder
    )
  }

  get orderIsCancellable(): boolean {
    return this.orderCancellationState.isCancellable
  }

  get errorOnLoad() {
    return _.get(this.$store.state.orderHistory, 'error.load')
  }

  get commentIsRequired(): boolean {
    return !_.isEmpty(this.code) && this.orderHistoryApiService.checkCancelCodeRequiresNoteOption(this.code!)
  }

  async created() {
    this.status = Status.Loading

    await this.initOrder()

    if (this.errorOnLoad) {
      this.modalMessage = '購入履歴が取得できませんでした。'
      this.showModal = true
      this.status = Status.Failed

      return
    }

    if (!this.orderIsCancellable) {
      this.redirectToOrder()

      return
    }

    this.status = Status.Completed
  }

  async initOrder(): Promise<void> {
    const orderId = this.queryOrderId

    await this.$store.dispatch('orderHistory/get', orderId)
  }

  redirectToOrder(): void {
    this.$router.replace(`/mypage/order/${this.queryOrderId}`)
  }

  async submit(): Promise<void> {
    if (!this.code) {
      this.modalMessage = 'キャンセル理由を選択してください。'
      this.showModal = true

      return
    }

    if (this.commentIsRequired && !this.comment) {
      this.modalMessage = '「その他」を選択された場合は具体的な理由もご記入ください。'
      this.showModal = true

      return
    }

    const confirmed = await this.confirm()
    if (!confirmed) {
      return
    }

    const reasonText = CancelReason.getText(this.code)

    if (!reasonText) {
      return
    }

    this.cancelApiStatus = Status.Loading

    const orderResult = await this.orderHistoryApiService.get(this.order.id)
    if (orderResult.isLeft()) {
      this.showError('キャンセルに失敗しました。※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。')
      this.cancelApiStatus = Status.Failed

      return
    }

    const orderStatus = orderResult.value.body.data.sales_order_status
    // キャンセル実行直前に今のステータスを再度確認している模様
    // isCancellableのチェックにEngineのステータスのチェックも含まれているので、
    // ここで弾かれるとしたらキャンセル画面を開いている間にステータスが変更されてキャンセルができなくなったケースなので、
    //  - 「決済完了」から「配送準備中」になりキャンセルを受け付けられなくなった
    //  - 「NP後払いエラー」から「再注文期限切れエラー」になりキャンセルを受け付けられなくなった
    // のようにEngineステータスの変化のみで十分に確認できる。
    if (!_.includes(['payment-done', 'payment-error'], orderStatus)) {
      this.showError('このご注文はキャンセルできません。')
      this.cancelApiStatus = Status.Failed

      return
    }

    const cancelResult = await this.orderHistoryApiService.cancel(
      this.order.id,
      this.code,
      reasonText,
      this.comment
    )

    if (cancelResult.isLeft()) {
      this.showError('キャンセルに失敗しました。※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。')
      this.cancelApiStatus = Status.Failed

      return
    }

    this.cancelApiStatus = Status.Completed

    // Refresh order list
    await this.$store.dispatch('orderHistory/list', { force: true })

    // This is a workaround because watcher is not triggered for the computed isLoading
    await this.$store.dispatch('view/stopLoading')

    this.$router.push(`/mypage/order/${this.order.id}/canceled`)
  }

  private showError(message: string) {
    this.modalMessage = message
    this.showModal = true
  }
}
